import numeral from 'numeral';
import { isObject } from 'lodash';
import { getCurrencySettingsByCode } from 'enums/country';

export const isNumber = (variable) => {
  if (variable === null || isObject(variable)) {
    return false;
  }
  return !Number.isNaN(Number(variable));
};

export const isEven = (number) => number % 2 === 0;

// TODO: for instance only get the value, the currency code
// will be implemented in a near future
const normalizeAmountObject = (amount) =>
  isObject(amount)
    ? { ...amount, value: parseFloat(amount.value) }
    : { value: parseFloat(amount), code: undefined };

export function formatCurrency(number, formatStr = '0,0[.]00') {
  const amountObject = normalizeAmountObject(number);
  if (!amountObject.code) {
    return numeral(amountObject.value).format(`$${formatStr}`);
  } else {
    const { symbol, thousandSeparator } = getCurrencySettingsByCode(amountObject.code);
    const formattedValue = numeral(amountObject.value)
      .format(formatStr)
      .replace(/,|\s/, thousandSeparator);
    return `${symbol}${formattedValue}`;
  }
}

export function formatToMillions(number) {
  return numeral(number).format('0.0a');
}

export function formatToThousands(number) {
  return numeral(number).format('0a');
}

export function formatToThousandsWithCurrency(number) {
  return numeral(number).format('$0a');
}

export function formatToIntegerWithCurrency(number) {
  return numeral(number).format('$0,0');
}

export function roundToTenths(number) {
  return `${numeral(number).format('0.0')}x`;
}

export function roundToMultiple(number, multiple) {
  return Math.round(Number(number) / multiple) * multiple;
}

export function formatCurrencyWithNegativeParentheses(number, formatStr) {
  if (number < 0) {
    return formatCurrency(number, '($0,0)');
  }

  return formatCurrency(number, formatStr);
}

export function formatNumber(number, formatStr = '($0,0)') {
  return numeral(number).format(formatStr);
}

// Fix all numbers to use only the K modifier
// This is the standard on the new UI
export function formatToOnlyThousands(number) {
  const cappedNumber = Math.round(Number(number) / 1000);

  if (cappedNumber === 0) return '0k';

  if (cappedNumber < 0) return `(${formatNumber(Math.abs(cappedNumber), '$0,0')}k)`;

  return `${formatNumber(cappedNumber, '$0,0')}k`;
}

export const getPercentageTrend = (initialValue, finalValue, percentageFactor = 100) =>
  Math.round(((finalValue - initialValue) / Math.abs(initialValue)) * percentageFactor);

export const humanizeFileSize = (bytes, decimalDigits = 0) => {
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  if (bytes === 0) return '0 Byte';
  const i = Math.floor(Math.log(bytes) / Math.log(1024));
  return `${(bytes / Math.pow(1024, i)).toFixed(decimalDigits)} ${sizes[i]}`;
};
